import { Button, SvgIconUrl } from 'common/components';

import { useI18n, usePopup } from 'common/hooks';
import { ModalAction } from 'common/redux/modal/initialState';
import svgIcons from 'common/svgIcons';

import './index.css';

const DepositForbidenPopup = () => {
  const { translate } = useI18n();
  const { hide } = usePopup();
  return (
    <div className='deposit-forbidden-popup'>
      <div className='icon-shadow deposit-forbidden-popup__image'>
        <SvgIconUrl symbol={svgIcons.LockIconInner()} />
      </div>
      <p className='deposit-forbidden-popup__text'>{translate('mobile:deposit-forbidden-popup:text')}</p>
      <Button large onClick={hide}>
        {translate('mobile:deposit-forbiden-popup:button')}
      </Button>
    </div>
  );
};

const config: ModalAction = {
  hideCloseIcon: true,
  closeOnClickOutside: false,
  animation: 'appearUp',
  wrapperClassName: 'deposit-forbidden-popup__wrapper',
};

export default () => ({
  component: <DepositForbidenPopup />,
  ...config,
});
